import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({
  mainContainer: {
    flexDirection: "column",
    alignItems: "center",
  },
  year: {
    fontFamily: "'Rubik',sans-serif",
    left: 0,
    fontSize: 24,
    textAlign: 'center',
    alignContent: 'center',
    height: 85,
    padding: "0px 25px",
    zIndex: 1,
    fontWeight: "500",
    PointerEvent: "none",
    lineHeight: 1.1,
    [emulatorScreen(theme)]: {
      lineHeight: 1.1
    },
    [mobileScreen(theme)]: {
      fontSize: 17,
      height: 50,
      lineHeight: 1.2
    },
  },
  q3Year: {
    fontFamily: "'Rubik',sans-serif",
    left: 0,
    fontSize: 24,
    textAlign: 'center',
    alignContent: 'center',
    height: 85,
    padding: "0px 25px",
    zIndex: 1,
    fontWeight: "500",
    PointerEvent: "none",
    lineHeight: 1.1,
    [emulatorScreen(theme)]: {
      lineHeight: 1.1
    },
    [mobileScreen(theme)]: {
      fontSize: 17,
      height: 61,
      lineHeight: 1.2
    },
  },
  imageConatiner: {
    width: 400,
    height: 325,
    borderRadius: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    cursor: "pointer",
    [emulatorScreen(theme)]: {
      width: 300,
      height: 250,
    },
    [mobileScreen(theme)]: {
      width: 260,
      height: 200,
    },
  },
  image: {
    height: "100%",
    width: "100%",
    borderRadius: 5,
  },

  tagContainer: {
    position: "absolute",
    top: -5,
    right: -5,
    width: 125,
    height: 50,
    borderRadius: 10,
    justifyContent: "center",
    alignItems: "center",
    [emulatorScreen(theme)]: {},
    [mobileScreen(theme)]: {},
  },
  tagText: {
    color: "#fff",
    fontFamily: "'Oswald', sans-serif",
    fontSize: 25,
    fontWeight: 600,
    [emulatorScreen(theme)]: {},
    [mobileScreen(theme)]: {},
  },
  opcityContainer: {
    height: "103%",
    width: "103%",
    opacity: 0.5,
    borderRadius: 10,
    position: "absolute",
    backgroundColor: "#3b8596",
    [emulatorScreen(theme)]: {},
    [mobileScreen(theme)]: {},
  },
  opcityGreyContainer: {
    height: "103%",
    width: "103%",
    opacity: 0.8,
    borderRadius: 10,
    position: "absolute",
    backgroundColor: "#bfbfbf",
    [emulatorScreen(theme)]: {},
    [mobileScreen(theme)]: {
      height: "105%",
      width: "104%",
    },
  },
  nextButton: {
    color: "#fff",
    backgroundColor: "#00b1d9",
    fontSize: "36px",
    fontWeight: "500",
    padding: "10px",
    borderRadius: "0px",
    fontFamily: "'Oswald', sans-serif",
    "&:hover": {
      backgroundColor: "#056f8a",
    },
    [emulatorScreen(theme)]: {},
    [mobileScreen(theme)]: {},
  },
  priceCpiText: {
    color: "#003E4C",
    fontWeight: "400",
    paddingTop: 10,
    fontSize: 20,

    // fontSize: 30,
    textAlign: "center",
    textTransform: "uppercase",
    fontFamily: "'Rubik',sans-serif",
    [emulatorScreen(theme)]: {},
    [mobileScreen(theme)]: {
      fontSize: 16,
    },
  },

  text: {
    color: "#003E4C",
    fontWeight: "500",
    textAlign: "center",
    textTransform: "uppercase",
    fontFamily: "'Rubik',sans-serif",
    fontSize: 20,
    [emulatorScreen(theme)]: {},
    [mobileScreen(theme)]: {
      fontSize: 16,
    },
  },
  priceCpiContainer: {
    width: 400,
    display: "flex",
    justifyContent: "space-between",
    [emulatorScreen(theme)]: {
      width: 300,
    },
    [mobileScreen(theme)]: {
      width: 260,
    },
  },
});
export default styles;
